import CheckConsumerDetail from "./CheckConsumerDetail";
const CheckConsumer={
     CheckConsumerDetail
}
export default CheckConsumer